import { useEffect, useState } from 'react';

export function useStore(store) {
  const [state, setState] = useState(store.getState());

  useEffect(() => {
    const onStoreChange = () => setState({ ...store.getState() });
    store.addListener('change', onStoreChange);
    return () => store.removeListener('change', onStoreChange);
  }, []);

  return state;
}
